export default "__VITE_ASSET__tKrvGnC6__"